import { Modal } from 'antd';
import React from 'react';

import ButtonWrap from '@/components/ButtonWrap';

import './style.scss';

interface IProps {
    onCancel?: () => void;
    onOk?: () => void;
    onDelete?: () => void;
    visible?: boolean;
    title?: string;
    type?: 'info' | 'success' | 'error' | 'warn' | 'warning' | 'confirm';
    width?: string | number;
    cancelText?: React.ReactNode;
    okText?: React.ReactNode;
    icon?: React.ReactNode;
    className?: string;
    footer?: React.ReactNode;
    children?: React.ReactNode;
    isFooterCancel?: boolean;
    showFooter?: boolean;
    top?: number;
    centered?: boolean;
    danger?: boolean;
    isBtnDelete?: boolean;
    isExportCsv?: boolean;
    onExportCsv?: () => void;
    maskClosable?: boolean;
    destroyOnClose?: boolean;
}

const ModalWrap: React.FC<IProps> = ({
    onCancel,
    onOk,
    onDelete,
    visible,
    className = '',
    cancelText,
    okText,
    title,
    isFooterCancel,
    top,
    width,
    footer,
    children,
    centered = true,
    danger,
    isBtnDelete = false,
    isExportCsv = false,
    onExportCsv,
    maskClosable = false,
    destroyOnClose = false,
}) => {
    return (
        <>
            <Modal
                className={`c-modal ${className}`}
                footer={
                    footer ? (
                        footer
                    ) : (
                        <div className="modal-footer">
                            {isFooterCancel ? (
                                <div className="btn-group">
                                    <ButtonWrap
                                        className="btn-cancel"
                                        onClick={onCancel}
                                        text={cancelText || `QUAY LẠI`}
                                    />
                                </div>
                            ) : (
                                <div className="modal-footer__wrap">
                                    <ButtonWrap className="btn-cancel" onClick={onCancel} text={cancelText || 'HỦY'} />
                                    {isBtnDelete && (
                                        <ButtonWrap
                                            // type="ghost"
                                            danger={true}
                                            className="btn-cancel"
                                            onClick={onDelete}
                                            text={'XÓA'}
                                        />
                                    )}
                                    <ButtonWrap
                                        className="btn-ok"
                                        onClick={onOk}
                                        type="primary"
                                        text={okText || `OK`}
                                        danger={danger}
                                    />
                                </div>
                            )}
                        </div>
                    )
                }
                title={title}
                visible={visible}
                onCancel={onCancel}
                width={width}
                centered={centered}
                maskClosable={maskClosable}
                destroyOnClose={destroyOnClose}
            >
                {children}
            </Modal>
        </>
    );
};

export default React.memo(ModalWrap);
